export const dateTimeFormats = {
	short: {
		month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	medium: {
		year: 'numeric', month: 'short', day: 'numeric'
	},
	long: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'
	},
	full: {
		year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'
	}
};
export const messages = {
    "login.form.title": "로그인",
    "login.form.hint.user": "로그인",
    "login.form.hint.password": "암호",
    "login.form.checkbox.remember-me": "로그인 정보 저장",
    "login.form.button.sign-in": "로그인",
    "login.form.message.invalid-user-credentials": "로그인 또는 패스워드가 잘못되었습니다.",
    "login.form.message.account-temporarily-locked": "계정이 일시적으로 잠겼습니다. 5분 후 다시 확인하십시오.",
    "login.form.message.user-required": "로그인 입력",
    "login.form.message.password-required": "비밀번호 입력",
    "login.form.button.forgot-password": "비밀번호를 잊으셨습니까?",
    "error.mfa-required.title": "2FA(2단계 인증) 설정",
    "error.mfa-required.message1": "계정을 보호하려면 2단계 인증(2FA)이 필요합니다.",
    "error.mfa-required.message2": "온라인 대시보드의 계정 설정으로 리디렉션됩니다. 2FA(2단계 인증)를 활성화한 다음에 설정 지시를 따르고 여기로 돌아오십시오.",
    "error.mfa-required.learnMore": "2FA(2단계 인증)에 대해 자세히 알아보기",
    "error.mfa-required.continue": "계속",
    "error.root-admin-login.title": "오류 403 – 금지됨",
    "error.root-admin-login.message": "읽기 전용 관리자로 로그인했습니다. 웹 복구 콘솔에 액세스하려면 고객 테넌트 사용자 또는 관리자로 로그인하십시오.",
    "error.server-busy.message": "서버가 작업 중입니다. 나중에 다시 시도하십시오.",
    "error.network-connection.title": "네트워크 연결 오류",
    "error.network-connection.message": "인터넷 연결을 확인하고 다시 시도하십시오.",
    "error.internal-server-error.title": "내부 서버 오류",
    "error.internal-server-error.message": "오류를 해결하려면 오류 세부 정보를 확인하여 지원팀에 문의하십시오.",
    "error.internal-server-error.copy.button": "복사"
};
